export function findScrollTargets(anchorElement: Element | null) {
  const scrollTargets: (Element | Window)[] = [window];
  let target = anchorElement;

  while (target) {
    const root = target.getRootNode();
    const parent =
      target.parentElement ?? (root instanceof ShadowRoot ? root.host : null);

    if (parent) {
      const { overflow, overflowY, overflowX } = getComputedStyle(parent);

      if (/(auto|scroll|hidden)/.test(overflow + overflowY + overflowX)) {
        scrollTargets.push(parent);
      }
    }

    target = parent;
  }

  return scrollTargets;
}
